import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Library() {
  const [items, setItems] = useState([]);
  const [starting, setStarting] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/library").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  const startReading = async (item) => {
    setStarting(item.id);
    try {
      const { data: full } = await api.get(`/library/${item.id}`);
      const { data: sess } = await api.post("/sessions/start", {
        source: "library",
        source_id: item.id,
        title: full.title,
        content: full.content,
      });
      navigate(`/reading/${sess.session_id}`);
    } catch (e) {
      toast.error("Could not open this reading.");
    } finally {
      setStarting(null);
    }
  };

  const categories = [...new Set(items.map((i) => i.category))];

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-6xl mx-auto px-6 lg:px-10 py-16 sm:py-20">
        <div className="text-[10px] tracking-[0.4em] uppercase text-ember-500 mb-4">Public Domain Library</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3" data-testid="library-title">
          A small library, deliberately chosen.
        </h1>
        <p className="text-sm text-forge-100/60 mb-12 max-w-2xl">
          Excerpts from voices that have shaped how humans think — from Athens to abolition to the Origin of Species.
        </p>

        {categories.map((cat) => (
          <section key={cat} className="mb-14">
            <h2 className="font-sans text-xs uppercase tracking-[0.3em] text-gold-500 mb-5">{cat}</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
              {items.filter((i) => i.category === cat).map((item) => (
                <button
                  key={item.id}
                  onClick={() => startReading(item)}
                  disabled={starting === item.id}
                  className="text-left bg-forge-900 hover:bg-forge-800 p-6 transition-all duration-300 group disabled:opacity-60"
                  data-testid={`library-item-${item.id}`}
                >
                  <div className="font-serif text-xl text-forge-100 group-hover:text-ember-400 transition-colors mb-2">{item.title}</div>
                  <div className="text-xs uppercase tracking-[0.25em] text-forge-100/40 mb-4">{item.author}</div>
                  <p className="text-sm text-forge-100/60 leading-relaxed line-clamp-3">{item.summary}</p>
                  <div className="mt-4 text-xs uppercase tracking-[0.25em] text-forge-100/30 group-hover:text-ember-500 transition-colors">
                    {starting === item.id ? "Opening…" : "Read →"}
                  </div>
                </button>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
}
